module.exports = __webpack_public_path__ + "img/service-sample.f15d96ff.jpeg";